import { Table } from '@mantine/core'
import { isEmpty, map } from 'lodash'
import React, { ReactElement } from 'react'

import Currency from '../../../../1stlog-ui/src/components/Currency'
import useFieldValue from '../../../../1stlog-ui/src/components/Field/useFieldValue'
import Icon from '../../../../1stlog-ui/src/components/Icon'
import { TOrderEntryCustomsItem } from '../../../../shipmetrics-shared/containers/OrderEntry/types'

type TCustomsProps = {}

const Customs = (props: TCustomsProps): ReactElement => {
  const {} = props

  const customsTerms = useFieldValue<string>('customsTerms')

  const customs = useFieldValue<TOrderEntryCustomsItem[]>('customs')

  if (isEmpty(customs)) {
    return <></>
  }

  return (
    <>
      <h4 className="mt-0">
        {i18n.t('customs', 'Verzollung')} ({customsTerms?.toUpperCase()})
      </h4>
      <div className="mb-2">
        <Table>
          <thead>
            <tr className="text-center">
              <th>{i18n.t('count', 'Anzahl')}</th>
              <th>
                {i18n.t('article_nunber_or_reference', 'Artikelnr./Referenz')}
              </th>
              <th>{i18n.t('label_country_origin', 'Ursprungsland')}</th>
              <th>
                {i18n.t('value_of_goods_per_unit', 'Warenwert pro Einheit')}
              </th>
              <th>{i18n.t('net_weight_in_kg', 'Nettogewicht in kg')}</th>
              <th>{i18n.t('label_goods_name', 'Warenbezeichnung')}</th>
              <th>{i18n.t('customs_tariff_number', 'Zolltarifnummer')}</th>
              <th>{i18n.t('customs_preference_short', 'Präferenzzollsatz')}</th>
            </tr>
          </thead>
          <tbody>
            {map(customs, (item) => (
              <tr key={item.id}>
                <td className="text-center">{item.count}</td>
                <td className="text-center">{item.articleNumber}</td>
                <td className="text-center">
                  <Icon
                    icon={`flag-icon flag-icon-${getCountryIcon(
                      item.originCountry,
                    )}`}
                  />{' '}
                  {item.originCountry}
                </td>
                <td className="text-center">
                  <Currency
                    value={item.value?.value}
                    currency={item.value?.currency}
                  />
                </td>
                <td className="text-center">{item.netWeight} kg</td>
                <td className="text-center">{item.description}</td>
                <td className="text-center">{item.tariffNumber}</td>
                <td className="text-center">
                  {item.preferenceCode || item.preferenceCode === '1' ? (
                    <Icon icon="far fa-check" />
                  ) : (
                    <Icon icon="far fa-times" />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  )
}

export default Customs

function getCountryIcon(shortCode: string): string {
  const value = shortCode.toLowerCase()
  switch (value) {
    case 'en':
      return 'gb'
    default:
      return value
  }
}
